import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import StatsMarquee from "./components/StatsMarquee";
import VideosSection from "./components/VideosSection";
import BrandGallery from "./components/BrandGallery";
import Footer from "./components/Footer";
import { VideoLightboxProvider } from "./components/VideoLightbox";
import LatestDropPopup from "./components/LatestDropPopup";
import LiveBanner from "./components/LiveBanner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function Home() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState(null);
  const [live, setLive] = useState(null);

  useEffect(() => {
    let alive = true;

    const fetchVideos = async () => {
      try {
        const res = await axios.get(`${API}/youtube/videos?limit=200`);
        if (alive) setVideos(res.data.videos || []);
      } catch (e) {
        if (alive) setError("Could not load videos right now.");
      } finally {
        if (alive) setLoading(false);
      }
    };

    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API}/youtube/stats`);
        if (alive) setStats(res.data);
      } catch (e) {
        // stats are optional
      }
    };

    const fetchLive = async () => {
      try {
        const res = await axios.get(`${API}/youtube/live`);
        if (alive) setLive(res.data);
      } catch (e) {
        // live is optional
      }
    };

    fetchVideos();
    fetchStats();
    fetchLive();
    // Re-poll live status every 90s while page is open
    const id = setInterval(fetchLive, 90_000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);

  const featured = videos[0] || null;
  const liveVideo = live?.is_live ? live.live : null;
  const upcomingLive = !live?.is_live && live?.upcoming?.length ? live.upcoming[0] : null;

  return (
    <VideoLightboxProvider>
      <LiveBanner live={liveVideo} />
      <div
        className={`App grain relative ${liveVideo ? "pt-12" : ""}`}
        data-testid="app-root"
      >
        <Nav liveActive={!!liveVideo} />
        <Hero featured={featured} stats={stats} upcomingLive={upcomingLive} />
        <StatsMarquee stats={stats} />
        <VideosSection videos={videos} loading={loading} error={error} />
        <BrandGallery stats={stats} />
        <Footer stats={stats} />
        <LatestDropPopup video={featured} />
      </div>
    </VideoLightboxProvider>
  );
}function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
